module.exports = __webpack_public_path__ + "img/Goals.80168278.png";